import { usePaginatedApi } from "../../../swr/useApi";
import { changeRequestsService } from "../../api_client";
import type { ChangeRequestDto, DocumentsQueryDto } from "../../../api";

export function useMyChangeRequests(query?: DocumentsQueryDto) {
  return usePaginatedApi<ChangeRequestDto, DocumentsQueryDto>({
    key: "my-change-requests",
    serviceMethod: async (queryParams) => {
      return await changeRequestsService.findMine(queryParams);
    },
    query,
  });
}
